<template>
    <div class="role-form">
        <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                    <div class="col-8">
                        <h3 class="mb-0">Role</h3>
                    </div>
                    <div class="col-4 text-right">
                        <router-link :to="'/roles/'">&laquo; Back to Roles</router-link>
                    </div>
                </div>
            </div>
            <template>
                <form @submit.prevent>
                    <div class="pl-lg-4">
                        <div class="row">
                            <div class="col-lg-6">
                                <base-input alternative=""
                                    label="Name"
                                    placeholder="Name"
                                    input-classes="form-control-alternative"
                                    v-model="model.name"
                                />
                            </div>
                            <div class="col-lg-6">
                                <base-input alternative=""
                                    label="Role"
                                    placeholder="Role"
                                    input-classes="form-control-alternative"
                                    disabled
                                    v-model="model.role"
                                />
                            </div>
                            <div class="col-lg-6">
                                <label class="form-control-label"> Role Type</label>
                                <select class="form-control" v-model="model.type">
                                    <option value="">Select Role Type</option>
                                    <option value="administrative">Administrative</option>
                                    <option value="managerial">Managerial</option>
                                    <option value="customer">Customer</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <hr class="my-4" />


                    <h6 class="heading-small text-muted mb-4">{{ model.type }} Functionalities</h6>

                    <div class="func-list">
                        <div class="row" v-for="(func,k) in functionalities[model.type]" :key="k">
                            <div class="col-lg-3">
                                <label>
                                    <input type="checkbox" name="functions" class="chxbx" :ref="func.key" :value="func.key" v-model="functions[func.key]">
                                    {{ func.name }}
                                </label>
                            </div>
                            <div class="col-lg-9">
                                <div class="row">
                                    <div :class="'col-lg-'+(func.size?func.size:3)" v-for="(sub,s) in func.subs" :key="s">
                                        <label>
                                            <input type="checkbox" name="functions" class="chxbx" 
                                                :disabled="!functions[func.key]" 
                                                :ref="sub.key" 
                                                :value="sub.key" 
                                                v-model="functions[sub.key]">
                                            {{ sub.name }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr class="my-4" />

                    <a @click="saveRole" class="btn">Save</a>
                </form>
            </template>
        </card>
    </div>
</template>
<script>
  export default {
    name: 'roles',
    data() {
      return {
        roleID: 'new',
        apiUrl: '/api/',
        model: { type : 'customer' },
        functions: {},
        functionalities: {
            administrative : [
                { key: 'actions',
                  name: 'Project Actions',
                  subs: [
                    { key: 'action_approve' , name: 'Approve'},
                    { key: 'project_close'  , name: 'Close'},
                    { key: 'project_delete' , name: 'Delete'},
                  ]
                },
                { key : 'exports' , 
                  name: 'Exports' , 
                  subs: [
                    { key: 'export_quote_full' ,  name: 'Full Quote List'}, 
                    { key: 'export_user_full'  , name: 'Full User List'},
                    { key: 'export_west_coast' , name: 'West Coast'},
                    { key: 'export_survey_ans' , name: 'Survey Answers'},
                  ]
                },
                { key: 'questionnaires',
                  name: 'Questionnaires',
                  subs: [
                    { key: 'questionnaire_add'   , name: 'Add'}, 
                    { key: 'questionnaire_edit'  , name: 'Edit'},
                    { key: 'questionnaire_delete', name: 'Delete'},
                  ]
                },
                { key: 'job_vacancies',
                  name: 'Job Vacancies',
                  subs: [
                    { key: 'job_add'   , name: 'Add'}, 
                    { key: 'job_edit'  , name: 'Edit'},
                    { key: 'job_delete', name: 'Delete'},
                  ]
                },
                { key: 'users',
                  name: 'Manage Users',
                  subs: [
                    { key: 'user_add'        , name: 'Add'}, 
                    { key: 'user_edit'       , name: 'Edit'},
                    { key: 'user_bulk_edit'  , name: 'Bulk Edit'},
                    { key: 'user_delete'     , name: 'Delete'},
                  ]
                },
                { key: 'followups',
                  name: 'Follow-ups',
                  size: '6',
                  subs: [
                    { key: 'followup_templates' , name: 'Manage Templates'}, 
                    { key: 'followup_send'      , name: 'Send Automated Follow-ups'},
                  ]
                },
                { key: '3dmodels',
                  name: '3d Models',
                  subs: [
                    { key: '3dmodel_add'   , name: 'Add'}, 
                    { key: '3dmodel_edit'  , name: 'Edit'},
                    { key: '3dmodel_delete', name: 'Delete'},
                  ]
                },
                { key: 'engrdbs', 
                  name: 'Engineering Database',
                  subs: [
                    { key: 'engrdb_add'   , name: 'Add'}, 
                    { key: 'engrdb_edit'  , name: 'Edit'},
                    { key: 'engrdb_delete', name: 'Delete'},
                  ]
                },
                { key: 'augmentir',
                  name: 'Augmentir',
                  size: '6',
                  subs: [
                    { key: 'augmentir_setting' , name: 'Setting Adjustments'},
                    { key: 'augmentir_tutorial', name: 'Tutorial Creation'},
                  ]
              },
            ],
            managerial : [
                { key: 'projects',
                  name: 'Own Projects',
                  subs: [
                    { key: 'project_view'  , name: 'View'}, 
                    { key: 'project_add'   , name: 'Add'}, 
                    { key: 'project_edit'  , name: 'Edit'},
                    { key: 'project_close' , name: 'Close'}
                  ]
                },
                { key: 'subprojects',
                  name: 'Sub-User Projects',
                  subs: [
                    { key: 'subproject_view'  , name: 'View'}, 
                    { key: 'subproject_add'   , name: 'Add'}, 
                    { key: 'subproject_edit'  , name: 'Edit'},
                    { key: 'subproject_close' , name: 'Close'},
                    { key: 'subproject_delete', name: 'Delete'},
                  ]
                },
                { key: 'actions',
                  name: 'Project Actions',
                  subs: [
                    { key: 'action_promote' , name: 'Promote'}, 
                    { key: 'action_approve' , name: 'Approve'},
                    { key: 'action_purchase', name: 'Purchase'},
                  ]
                },
                { key: 'gens',
                  name: 'File Generation',
                  subs: [
                    { key: 'generate_drill'   , name: 'Drills'}, 
                    { key: 'generate_datatag' , name: 'Data Tags'},
                  ]
                },
            ],
            customer : [
                { key: 'projects',
                  name: 'Own Projects / Modernization',
                  subs: [
                    { key: 'project_view'  , name: 'View'}, 
                    { key: 'project_add'   , name: 'Add'}, 
                    { key: 'project_edit'  , name: 'Edit'},
                    { key: 'project_close' , name: 'Close'},
                  ]
                },
                { key: 'constructions',
                  name: 'Construction',
                  subs: [
                    { key: 'construction_view'  , name: 'View'}, 
                    { key: 'construction_add'   , name: 'Add'}, 
                    { key: 'construction_edit'  , name: 'Edit'},
                    { key: 'construction_close' , name: 'Close'},
                  ]
                },
                { key: 'supports',
                  name: 'Support Access',
                  subs: [
                    { key: 'support_view'  , name: 'View'}, 
                    { key: 'support_add'   , name: 'Add'}, 
                    { key: 'support_edit'  , name: 'Edit'},
                    { key: 'support_close' , name: 'Close'},
                  ]
                },
                { key: 'spares',
                  name: 'Spare Parts',
                  subs: [
                    { key: 'spare_view'    , name: 'View items'},
                    { key: 'spare_purchase', name: 'Purchase'},
                  ]
                },
                { key: 'actions',
                  name: 'Project Actions',
                  subs: [
                    { key: 'action_order'   , name: 'Order'},
                    { key: 'action_purchase', name: 'Purchase'},
                    { key: 'action_claim'   , name: 'Submit Claim'},
                  ]
                }
            ],
        }
      }
    },
    created() {
        var user = localStorage.getItem('user');
        if ( !user ) this.$router.push('login');
        this.user = JSON.parse(user);

        const role_id = this.$route.params.id;
        if ( role_id > 0 ) this.getRole(role_id);
    },
    methods: {
        inFunction(role) {
            if ( !this.model.functions ) return false;
            return this.model.functions.includes(role);
        },
        saveRole() {
            var fns = [];

            for(var i in this.$refs) {
                const _el = this.$refs[i];
                if ( Array.isArray(_el) && _el[0] ) {
                    var item = _el[0];
                    if ( !item.disabled && item.checked ) {
                        fns.push(item.value);
                    }
                }
            }
            fns = fns.join(',');

            var data = {
                name : this.model.name,
                type : this.model.type,
                functions : fns
            };

            const api = '/api/save-role/'+this.roleID;
            this.$http
                .get(api,{ params: data })
                .then((response) => {
                    alert('Role changes saved!');
                    console.log(response)
                })
                .catch((error) => {
                    console.log(error)
                });

            return false;
        },
        getRole(role_id) {
            const api = this.apiUrl+'role/'+role_id;
            this.isLoading = true;
            this.$http.get(api).then((response) => {
                this.isLoading = false;
                this.model = response.data;
                this.roleID = this.model.id;
                var functions = {};
                this.model.functions.split(',').map(function(f){
                    functions[f] = f;
                });
                this.functions = functions;
                console.log(this.functions);
            });
        },
    }
  };
</script>
<style>
  .roles-list .projects-table { max-width: 100%; }
  .roles-list .projects-table th, .roles-list .projects-table td{ text-align: left; white-space: normal; }
  .roles-list .projects-table th{ text-align: center; background: #000; color: #FFF; }
  .role-form .btn-wrap{ white-space: nowrap; margin-top: 4px; }
  .role-form .btn{
    border-radius: 0;
    width: 120px;
    padding: 7px;
    border: 0;
    letter-spacing: .3px;
    color: #fff;
    font-size: 11px;
    text-decoration: none;
    background: #5bc0de;
    display: inline-block;
  }
  .roles-list .btn-success{ background: #5cb85c; }
  .roles-list .projects-table .vtop{ vertical-align: top; }
  .roles-list .projects-table .vright{ text-align: right; }
  .chxbx { width: 17px; height: 17px; float: left; margin: 1px 7px 0px 0; }
  .role-form .func-list > div { padding: 8px 0 0; }
  .role-form .func-list > div:nth-child(even){ background: #e3e3e3; }
</style>
